<!--
  - @copyright Internet Business Partner, all rights reserved (c) 2020
  - @author    Marek Lisiecki <m.lisiecki@ibp.net.pl>
  - @license   Commercial
  -->

<template>
    <div class="ara-header" id="header" data-url="/home" ref="sliderContainer">
        <div class="frame active" style="background-image: url(/assets/slider-01.jpg);"></div>
        <div class="frame" style="background-image: url(/assets/slider-02.jpg);"></div>
        <div class="frame" style="background-image: url(/assets/slider-03.jpg);"></div>
        <div class="frame" style="background-image: url(/assets/slider-04.jpg);"></div>
    </div>
</template>

<script>
const prepareSlider = async (sliderData, sliderFrames) => {
    for (let i = 0; i < sliderFrames.length; i++) {
        if (sliderData[i].txt.trim() != '' && sliderData[i].url.trim() != '') {
            sliderFrames[i].innerHTML = `
                <div class="frameLink">
                    <a href="${sliderData[i].url}">${sliderData[i].txt}</a>
                </div>
            `;
        }
    }
};

const slider = async (ref) => {
    const sliderFrames = ref.querySelectorAll('div');

    const sliderActive = function (frameNumber, frameDelay) {
        if (++frameNumber >= sliderFrames.length) {
            frameNumber = 0;
        }

        for (let i = 0; i < sliderFrames.length; i++) {
            sliderFrames[i].classList.remove('active');
            if (i == frameNumber) {
                sliderFrames[i].classList.add('active');
            }
        }

        setTimeout(function () {
            sliderActive(frameNumber, frameDelay);
        }, frameDelay);
    };

    const sliderData = await fetch(
        process.env.VUE_APP_XHR,
        {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                mode: 'cms',
                type: 'slider'
            })
        }
    )

    let xhrResponse = await sliderData.json();
    await prepareSlider(xhrResponse, sliderFrames);
    await setTimeout(function () {
        sliderActive(0, 4000);
    }, 4000);
}

export default {
    name: "Slider",
    data () {
        return {
            slider: null
        }
    },
    mounted () {
        this.slider = slider(this.$refs.sliderContainer);
    },
    beforeUnmount () {
        clearTimeout(this.slider);
        this.slider = null;
    }
}
</script>

<style scoped lang="scss">
.ara-header {
    width: 100%;
    height: 600px;
    position: relative;
    z-index: 0;

    > div.frame {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        opacity: 0;
        transition: opacity 300ms ease-in-out, z-index 600ms ease-in-out;
        z-index: 0;

        &.active {
            opacity: 1;
            z-index: 10;
        }

        ::v-deep(.frameLink) {
            display: inline-block;
            background-color: rgba(0, 0, 0, .7);
            padding: 3vh 4vh;
            margin: 2vw;
            opacity: 0;
            transition: all 600ms ease-in-out 100ms;
            transform: translateX(-100px);

            a {
                text-decoration: none;
                color: #eeeeee;
                font: 4vh 'Google Sans';
            }
        }

        &.active ::v-deep(.frameLink){
            opacity: 1;
            transform: translateX(0px);
        }
    }
}

@media all and (max-width: 800px) {
    .ara-header {
        width: 100vw;
        height: 50vh;
    }
}
</style>